export default {
  form: {
    address: {
      label: 'Indirizzo',
      placeholder: 'Indirizzo',
    },
    zip_code: {
      label: 'CAP',
      placeholder: 'CAP',
    },
    city: {
      label: 'Città',
      placeholder: 'Città',
    },
    start_time: {
      label: 'Orario di inizio',
      placeholder: 'es. 11:00',
    },
    name: {
      label: 'Nome della location (opzionale)',
      placeholder: 'es. Accanto alla Fernsehturm',
      tooltip: 'Inserire un nome per la location aiuta i clienti a identificarla, ad es. "Accanto alla Fernsehturm"',
    },
    note: {
      label: 'Nota',
      placeholder: 'Inserisci nota',
    },
  },
  buttons: {
    add_location: 'Aggiungi location',
  },
};
